<template>
  <div class="page">
    <div class="page-container">
      <template v-if="!applied">
        <div class="page-title">申报合作项目</div>
        <div class="page-steps w800">
          <a-steps progress-dot size="small" class="v-my-lg" :current="currentStep">
            <a-step title="填写项目信息表" />
            <a-step title="填写项目预算明细表" />
            <a-step title="提交审核" />
          </a-steps>
        </div>
        <transition name="slide-fade" mode="out-in">
          <template v-if="currentStep == 0">
            <div class="w1100">
              <div class="panel">
                <h3 class="text-center" style="line-height: 40px">项目基本信息</h3>
                <div class="panel-body">
                  <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                    <a-form-model-item :colon="false" v-if="project.reviewResult === 0" :label-col="{ span: 3 }" :wrapper-col="{ span: 17 }">
                      <span slot="label"></span>
                      <a-alert class="v-mb-sm no-border" type="error">
                        <div slot="message">
                          <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />此项目申请已被驳回</div>
                          <div class="flex v-mt-xs">
                            <span class="text-right text-grey">审核意见：</span>
                            <span class="col text-red" v-html="$utils.convertToHtml(project.reviewOpinion)"></span>
                          </div>
                        </div>
                      </a-alert>
                    </a-form-model-item>
                    <a-row :gutter="0">
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="type">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目类型
                          </span>
                          <a-select placeholder="选择项目类型" v-model="form.type" style="width: 220px" ref="type" @select="onTypeSelect">
                            <a-select-option :value="11">公募合作</a-select-option>
                            <a-select-option :value="12">专项基金</a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="0">
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="name">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目名称
                          </span>
                          <a-input placeholder="项目名称" allowClear v-model="form.name" ref="name" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="amount">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            筹款目标金额
                          </span>
                          <div class="input-wrapper">
                            <a-input-number v-model="form.amount" ref="amount" placeholder="目标金额" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear style="width: 220px" />
                            <span class="input-unit">元</span>
                          </div>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="0">
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="period">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            协议周期
                          </span>
                          <a-range-picker v-model="form.contractDates" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateRangeChange" ref="datePicker" style="width: 220px" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="period">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            实施时间
                          </span>
                          <a-range-picker v-model="form.dates" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateRangeChange2" ref="datePicker2" style="width: 220px" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col span="12">
                        <a-form-model-item :colon="false">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目负责人
                          </span>
                          <a-input allowClear v-model="form.supervisor" ref="supervisor" style="width: 220px" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            负责人联系电话
                          </span>
                          <a-input allowClear v-model="form.supervisorPhone" ref="supervisorPhone" style="width: 220px" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" label="直接受益人数">
                          <a-input allowClear v-model="form.bnfPeople" ref="bnfPeople" style="width: 220px" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" label="间接受益人数">
                          <a-input allowClear v-model="form.bnfPeopleIndirect" ref="bnfPeopleIndirect" style="width: 220px" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" label="受助对象" :label-col="{ span: 3 }" :wrapper-col="{ span: 17 }">
                          <a-select mode="multiple" placeholder="选择受助对象" show-search v-model="form.recipients" style="width: 100%" allowClear ref="recipients">
                            <a-select-option v-for="item in recipientTypes" :key="item.value === void 0 ? item.label : item.value">
                              {{ item.label }}
                            </a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="0">
                      <a-col span="24">
                        <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="addr">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            实施地点
                          </span>
                          <template v-if="addressList.length > 0">
                            <div class="flex items-center" v-for="(item, index) in addressList" :key="index">
                              <div style="width: calc(100% - 160px)">
                                <a-input-group compact>
                                  <a-cascader changeOnSelect style="width: 320px" expand-trigger="hover" :show-search="{ cascaderFilter }" :options="districts" placeholder="选择地区" v-model="item.districts" :ref="`districts-${index}`" />
                                  <a-input style="width: calc(100% - 330px)" placeholder="详细地址" allowClear v-model="item.addr" :ref="`addr-${index}`" />
                                </a-input-group>
                              </div>
                              <a-space>
                                <a-button size="small" type="primary" icon="plus" title="添加" @click="onAddAddress(index + 1)"></a-button>
                                <a-button size="small" type="indigo" icon="minus" title="删除" @click="onRemoveAddress(index)" v-if="addressList.length > 1"></a-button>
                              </a-space>
                            </div>
                          </template>
                          <a-button size="small" type="primary" icon="plus" @click="onAddAddress(0)" v-else>添加实施地点</a-button>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col span="24">
                        <a-form-model-item :colon="false" prop="rsState" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            申请项目概述
                          </span>
                          <a-textarea :auto-size="{ minRows: 6 }" v-model="form.summary" ref="summary" placeholder="项目概述" style="width: 100%" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" prop="capitalPoolId" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            项目管理人员
                          </span>
                          <div class="text-left">
                            <a-button size="small" type="primary" icon="plus" @click="openMemberForm()">添加人员</a-button>
                          </div>
                          <a-table class="list-table" size="small" :bordered="true" :pagination="false" :data-source="memberList" :scroll="{ x: '100%' }" row-key="uid">
                            <a-table-column title="#" data-index="index" :width="50" align="center">
                              <template slot-scope="text, record, index">
                                {{ index + 1 }}
                              </template>
                            </a-table-column>
                            <a-table-column title="人员类型" data-index="memberDuty" :width="90" align="center">
                              <template slot="duty" slot-scope="text, record, index">
                                <a-select size="small" placeholder="选择人员类型" v-model="record.memberDuty" style="width: 100%" allowClear v-if="record.editing" :ref="`memberDuty${index}`">
                                  <a-select-option v-for="item in duties" :key="item.value === void 0 ? item.label : item.value">
                                    {{ item.label }}
                                  </a-select-option>
                                </a-select>
                                <span v-else>{{ record.memberDuty }}</span>
                              </template>
                            </a-table-column>
                            <a-table-column title="姓名" data-index="memberName" :width="80" align="center">
                              <template slot="name" slot-scope="text, record, index">
                                <a-input v-model="record.memberName" size="small" :ref="`memberName${index}`" v-if="record.editing" />
                                <span v-else>{{ record.memberName }}</span>
                              </template>
                            </a-table-column>
                            <a-table-column title="职务" data-index="memberPost" :ellipsis="true" :width="80" align="center">
                              <template slot="name" slot-scope="text, record, index">
                                <a-input v-model="record.memberPost" size="small" :ref="`memberPost${index}`" v-if="record.editing" />
                                <span v-else>{{ record.memberPost }}</span>
                              </template>
                            </a-table-column>
                            <a-table-column title="联系电话" data-index="phone" :ellipsis="true" :width="105" align="center">
                              <template slot="name" slot-scope="text, record, index">
                                <a-input v-model="record.phone" size="small" :ref="`phone${index}`" v-if="record.editing" />
                                <span v-else>{{ record.phone }}</span>
                              </template>
                            </a-table-column>
                            <a-table-column title="工作经验" data-index="experience" :ellipsis="true" align="left">
                              <template slot="name" slot-scope="text, record, index">
                                <a-input v-model="record.experience" size="small" :ref="`experience${index}`" v-if="record.editing" />
                                <span v-else>{{ record.experience }}</span>
                              </template>
                            </a-table-column>
                            <a-table-column title="操作" data-index="action" :width="60" align="center">
                              <template slot-scope="text, record, index">
                                <a-space class="table-actions" :size="4">
                                  <span class="table-action" title="编辑" @click="openMemberForm(record)"><a-icon type="form" /></span>
                                  <span class="table-action text-red" title="删除" @click="onRemoveMember(index)"><a-icon type="close" /></span>
                                </a-space>
                              </template>
                            </a-table-column>
                          </a-table>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" prop="rsState" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            上传项目文件
                          </span>
                          <div class="text-grey font-xs">请上传以下3份文件，可点击选择或拖拽文件至上传区域上传</div>
                          <a-row :gutter="12" class="v-mt-sm" style="margin-bottom: 12px">
                            <a-col span="8">
                              <a-upload-dragger
                                class="avatar-uploader"
                                :action="`${baseURL}/file/upload`"
                                :data="{
                                  params: JSON.stringify({ fileMark, projectId, fileBelongId: projectId, fileType: 101, fileSign: 'P01' }),
                                }"
                                :show-upload-list="{
                                  showPreviewIcon: true,
                                  showRemoveIcon: true,
                                  showDownloadIcon: true,
                                }"
                                :file-list="fileList1"
                                :before-upload="beforeUploadFile"
                                @preview="handlePreviewFile"
                                @change="info => handleUploadChange(info, 'fileList1', -1)"
                                @download="({ fileId, name }) => downloadFile({ fileId, belongId: projectId, fileSign: 'P01', fileName: name })"
                                accept=".doc, .docx, .pdf"
                                ref="fileList1"
                              >
                                <div class="v-pa-xs">
                                  <a-icon type="upload" />
                                  <p class="font-xs">项目合作协议及承诺书<span class="text-red">（必传）</span></p>
                                </div>
                              </a-upload-dragger>
                            </a-col>
                            <a-col span="8">
                              <a-upload-dragger
                                class="avatar-uploader"
                                :action="`${baseURL}/file/upload`"
                                :data="{
                                  params: JSON.stringify({ fileMark, projectId, fileBelongId: projectId, fileType: 102, fileSign: 'P01' }),
                                }"
                                :show-upload-list="{
                                  showPreviewIcon: true,
                                  showRemoveIcon: true,
                                  showDownloadIcon: true,
                                }"
                                :file-list="fileList2"
                                :before-upload="beforeUploadFile"
                                @preview="handlePreviewFile"
                                @change="info => handleUploadChange(info, 'fileList2')"
                                @download="({ fileId, name }) => downloadFile({ fileId, belongId: projectId, fileSign: 'P01', fileName: name })"
                                accept=".doc, .docx, .pdf"
                                ref="fileList2"
                              >
                                <div class="v-pa-xs">
                                  <a-icon type="upload" />
                                  <p class="font-xs">合作申请书<span class="text-red">（必传）</span></p>
                                </div>
                              </a-upload-dragger></a-col
                            >
                            <a-col span="8">
                              <a-upload-dragger
                                class="avatar-uploader"
                                :action="`${baseURL}/file/upload`"
                                :data="{
                                  params: JSON.stringify({ fileMark, projectId, fileBelongId: projectId, fileType: 103, fileSign: 'P01' }),
                                }"
                                :show-upload-list="{
                                  showPreviewIcon: true,
                                  showRemoveIcon: true,
                                  showDownloadIcon: true,
                                }"
                                :file-list="fileList3"
                                :before-upload="beforeUploadFile"
                                @preview="handlePreviewFile"
                                @change="handleUploadBudgets"
                                @download="({ fileId, name }) => downloadFile({ fileId, belongId: projectId, fileSign: 'P01', fileName: name })"
                                accept=".xls, .xlsx"
                                ref="fileList3"
                              >
                                <div class="v-pa-xs">
                                  <a-icon type="upload" />
                                  <p class="font-xs">项目预算表<span class="text-red">（必传）</span></p>
                                </div>
                              </a-upload-dragger></a-col
                            >
                          </a-row>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="24">
                        <a-form-model-item :colon="false" prop="rsState" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                          <span slot="label">
                            其他项目文件
                          </span>
                          <div class="text-grey font-xs">上传其他项目文件件，如调查问卷、项目传播计划等，支持图片、WORD文档及PDF格式，可上传多份</div>
                          <a-upload-dragger
                            class="avatar-uploader"
                            :action="`${baseURL}/file/upload`"
                            :data="{
                              params: JSON.stringify({ fileMark, projectId, fileBelongId: projectId, fileType: 104, fileSign: 'P01' }),
                            }"
                            :show-upload-list="{
                              showPreviewIcon: true,
                              showRemoveIcon: true,
                              showDownloadIcon: true,
                            }"
                            :file-list="fileList4"
                            :before-upload="beforeUploadFile"
                            @preview="handlePreviewFile"
                            @change="info => handleUploadChange(info, 'fileList4', -1)"
                            @download="({ fileId, name }) => downloadFile({ fileId, belongId: projectId, fileSign: 'P01', fileName: name })"
                            accept=".doc, .docx, .xls, .xlsx, .pdf, .png, .jpg, .jpeg, .gif"
                            ref="fileList4"
                          >
                            <div class="v-pa-xs">
                              <a-icon type="upload" />
                              <p class="font-xs">其他项目文件</p>
                            </div>
                            </a-upload-dragger>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-form-model>
                </div>
              </div>
              <div class="text-center v-mt-sm v-mb-lg">
                <a-space>
                  <a-button icon="check" type="indigo" key="draft" @click="handleSave(false)" :loading="saving">保存初稿</a-button>
                  <a-button icon="swap-right" type="primary" @click="nextStep">下一步，填报项目预算</a-button>
                  <a-button icon="undo" type="indigo" @click="handleReset">重置</a-button>
                  <a-button icon="left" type="default" @click="$router.go(-1)">返回</a-button>
                </a-space>
              </div>
            </div>
          </template>
          <template v-else-if="currentStep == 1">
            <div class="">
              <div class="panel">
                <div class="panel-body">
                  <div class="panel-info-section">
                    <div class="panel-info-section-title">
                      <a-icon type="caret-right" class="text-primary" />
                      <span class="text-bold">项目基本信息</span>
                    </div>
                    <table class="table table-plain v-mb-sm">
                      <tbody>
                        <tr>
                          <th width="165">项目名称</th>
                          <td width="36%">{{ form.name }}</td>
                          <th width="165">项目类型</th>
                          <td>
                            <template v-if="form.type == 11">公募合作</template>
                            <template v-else-if="form.type == 12">专项基金</template>
                          </td>
                        </tr>
                        <tr>
                          <th>项目负责人</th>
                          <td>{{ form.supervisor }}</td>
                          <th>负责人联系电话</th>
                          <td>{{ form.supervisorPhone }}</td>
                        </tr>
                        <tr>
                          <th>项目协议周期</th>
                          <td>{{ form.contractDates.length ? form.contractDates[0]+ '~' + form.contractDates[1] : '' }}</td>
                          <th>项目实施周期</th>
                          <td>{{ form.dates.length ? form.dates[0]+ '~' + form.dates[1] : '' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="panel-info-section">
                    
                    <div class="flex items-center">
                      <div class="panel-info-section-title">
                        <a-icon type="caret-right" class="text-primary" />
                        <span class="text-bold">项目预算明细</span>
                      </div>
                      <a-space :size="4" class="v-ml-auto">
                        <a-button size="small" icon="plus" type="indigo" @click="handleNewTask('append')">添加费用明细</a-button>
                        <!-- <a-button size="small" icon="import" type="primary">导入预算表</a-button> -->
                      </a-space>
                    </div>
                    <div class="flex">
                      <div class="col">
                        <a-table
                          key="table-edit"
                          class="list-table"
                          size="small"
                          rowKey="uid"
                          :expanded-row-keys.sync="expandedBudgetKeys"
                          :pagination="false"
                          :data-source="budgets"
                          :scroll="{ x: '100%' }"
                          :expand-icon-column-index="1"
                        >
                          <a-table-column title="操作" data-index="action" :width="90" align="center" fixed="left">
                            <template slot-scope="text, record, index">
                              <a-space class="icon-actions" :size="2" v-if="!record.sum">
                                <span class="icon-action" title="编辑" @click="record.editing = true" v-if="!record.editing"><a-icon type="form" /></span>
                                <span class="icon-action" title="确定" @click="record.editing = false" v-else><a-icon type="check" /></span>
                                <a-dropdown placement="bottomLeft">
                                  <span class="icon-action" title="添加"><a-icon type="plus" /></span>
                                  <a-menu slot="overlay">
                                    <template v-if="record.isRoot">
                                      <a-menu-item key="before" @click="handleNewTask('before', record, index)">
                                        <a-icon class="text-indigo" type="border-top" />
                                        向前添加费用分类
                                      </a-menu-item>
                                      <a-menu-item key="after" @click="handleNewTask('after', record, index)">
                                        <a-icon class="text-indigo" type="border-bottom" />
                                        向后添加费用分类
                                      </a-menu-item>
                                      <a-menu-item key="append" @click="handleNewSubTask('append', record, index)">
                                        <a-icon class="text-indigo" type="border-right" />
                                        添加费用明细
                                      </a-menu-item>
                                    </template>
                                    <template v-else>
                                      <a-menu-item key="before" @click="handleNewSubTask('before', record, index)">
                                        <a-icon class="text-indigo" type="border-top" />
                                        向前添加费用明细
                                      </a-menu-item>
                                      <a-menu-item key="after" @click="handleNewSubTask('after', record, index)">
                                        <a-icon class="text-indigo" type="border-bottom" />
                                        向后添加费用明细
                                      </a-menu-item>
                                    </template>
                                  </a-menu>
                                </a-dropdown>
                                <span class="icon-action text-red" title="删除" @click="handleRemoveTask(record, index)"><a-icon type="delete" /></span>
                              </a-space>
                            </template>
                          </a-table-column>
                          <a-table-column data-index="name" :ellipsis="true" :width="280" align="left" fixed="left">
                            <span slot="title">
                              <i class="required-mark">*</i>
                              费用名称
                            </span>
                            <template slot-scope="text, record">
                              <div class="relative-position flex items-center" :style="{ display: 'inline-block', width: hasChildren ? `calc(100% - ${record.isRoot ? 25 : 45}px)` : '100%' }">
                                <a-input size="small" :placeholder="record.isRoot ? '费用分类名称' : '费用明细名称'" style="width: 100%" v-model="record.name" :ref="`budgetName-${record.uid}`" v-if="record.editing" />
                                <span :class="{ 'text-bold': record.sum }" v-else>{{ record.name || '-' }}</span>
                                <a-tooltip placement="top" :title="record.isRoot ? '费用分类名称' : '费用明细名称'" v-if="!record.name || !record.name.trim()">
                                  <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                </a-tooltip>
                              </div>
                            </template>
                          </a-table-column>
                          <a-table-column data-index="cate" :ellipsis="true" :width="300" align="left">
                            <span slot="title">
                              <i class="required-mark">*</i>
                              费用类别
                            </span>
                            <template slot-scope="text, record, index">
                              <div class="relative-position" v-if="!record.isRoot">
                                <a-input-group compact v-if="record.editing">
                                  <a-select size="small" style="width: 125px" placeholder="请选择分类" v-model="record.cateRoot" :ref="`cateRoot-${record.uid}`" @change="value => onCateRootChange(value, record, index)">
                                    <a-select-option v-for="item in rootFinCates" :key="item">
                                      <template v-if="item == 1">项目费</template>
                                      <template v-else-if="item == 2">申请人管理费</template>
                                      <template v-else-if="item == 3">美丽心灵管理费</template>
                                    </a-select-option>
                                  </a-select>
                                  <a-select size="small" style="width: calc(100% - 125px)" placeholder="请选择二级类别" v-model="record.cateId" :ref="`cateId-${record.uid}`" @change="value => onCateChange(value, record, index)">
                                    <a-select-option v-for="item in finCates.filter(d => d.cateRoot == record.cateRoot)" :key="item.cateId">{{ item.cateName }}</a-select-option>
                                  </a-select>
                                </a-input-group>
                                <span v-else>
                                  <template v-if="record.cateRoot == 1">项目费</template>
                                  <template v-else-if="record.cateRoot == 2">申请人管理费</template>
                                  <template v-else-if="record.cateRoot == 3">美丽心灵管理费</template><template v-if="record.cateName">（{{ record.cateName }}）</template>
                                </span>
                                <a-tooltip placement="top" title="未设置费用类别" v-if="!record.cateRoot || !record.cateId" style="right: 4px">
                                  <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                </a-tooltip>
                              </div>
                            </template>
                          </a-table-column>
                          <a-table-column data-index="year" :width="90" align="center" :ellipsis="true">
                            <span slot="title">
                              <i class="required-mark">*</i>
                              费用年份
                            </span>
                            <template slot-scope="text, record">
                              <div class="relative-position" v-if="!record.isRoot">
                                <a-date-picker mode="year" size="small" placeholder="请选择" v-model="record.year" :open="record.showYearPanel" :ref="`year-${record.uid}`" @openChange="status => onYearPanelOpen(status, record)" format="YYYY" value-format="YYYY" @panelChange="value => onYearChange(value, record)" style="width: 100%" allow-clear v-if="record.editing" />
                                <span v-else>{{ record.year || '-' }}</span>
                                <a-tooltip placement="top" title="未设置费用年份" v-if="!record.year">
                                  <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                </a-tooltip>
                              </div>
                            </template>
                          </a-table-column>
                          <a-table-column title="单价" data-index="price" :width="120" align="right" :ellipsis="true">
                            <template slot-scope="text, record">
                              <div class="relative-position" v-if="!record.isRoot">
                                <a-input-number class="no-handler text-right" size="small" v-model="record.price" @change="e => handleInputChange(record)" :min="0" style="width: 100%" v-if="record.editing" />
                                <span v-else>{{ record.price ? $utils.thousands(record.price) : '-' }}</span>
                                <!-- <a-tooltip placement="top" title="未输入单价" v-if="!record.price">
                                  <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                </a-tooltip> -->
                              </div>
                            </template>
                          </a-table-column>
                          <a-table-column title="数量" data-index="quantity" :width="90" align="right">
                            <template slot-scope="text, record">
                              <div class="relative-position" v-if="!record.isRoot">
                                <a-input-number class="no-handler text-right" size="small" v-model="record.quantity" @change="e => handleInputChange(record)" :min="0" style="width: 100%" v-if="record.editing" />
                                <span v-else>{{ record.quantity || '-' }}</span>
                                <!-- <a-tooltip placement="top" title="未输入数量" v-if="!record.quantity">
                                  <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                </a-tooltip> -->
                              </div>
                            </template>
                          </a-table-column>
                          <a-table-column data-index="amount" :width="200" align="right">
                            <span slot="title">
                              <i class="required-mark">*</i>
                              预算金额
                            </span>
                            <template slot-scope="text, record">
                              <div class="relative-position" v-if="!record.isRoot">
                                <a-input-number class="no-handler text-right" size="small" v-model="record.amount" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" :min="0" :ref="`amount-${record.uid}`" style="width: 100%" v-if="record.editing" />
                                <span v-else>{{ record.amount ? $utils.thousands(record.amount) : '-' }}</span>
                                <a-tooltip placement="top" title="未设置预算金额" v-if="!record.amount">
                                  <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                </a-tooltip>
                              </div>
                              <span class="text-bold" v-else>{{ record.amount ? $utils.thousands(record.amount) : '-' }}</span>
                            </template>
                          </a-table-column>
                          <a-table-column title="预算备注" data-index="remark" :width="250" align="left">
                            <template slot-scope="text, record" v-if="!record.isRoot">
                              <a-input size="small" v-model="record.remark" style="width: 100%" v-if="record.editing"/>
                              <span v-else>{{ record.remark }}</span>
                            </template>
                          </a-table-column>
                        </a-table>
                      </div>
                    </div>
                    <div class="flex items-center v-mt-xs" v-if="budgets.length > 0">
                      <span class="col font-xs">
                        提示：
                        <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                        表示项不符合要求，提交至审核时有
                        <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                        标志将无法提交。
                      </span>
                    </div>
                    <div class="text-center v-my-lg">
                      <a-space>
                        <a-button icon="arrow-left" type="indigo" key="draft" @click="currentStep=0">返回上一步</a-button>
                        <a-button icon="check" type="indigo" key="draft" @click="handleConfirm(false)" :loading="saving">保存初稿</a-button>
                        <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirm(true)" :loading="saving">提交审核</a-button>
                        <a-button icon="rollback" type="default" key="backward" @click="$router.push('../list')">返回我的项目</a-button>
                      </a-space>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </transition>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您申报的合作项目已提交审核，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="$router.push(`view?id=${projectId}`)">查看项目</a-button>
            <a-button key="back" @click="$router.push('../list')">返回我的项目</a-button>
          </template>
        </a-result>
      </template>
    </div>
    <!-- 成员弹窗 -->
    <a-modal :visible="memberModal" :width="500" @cancel="cancelMemberModal" @ok="onSaveMember" centered :title="memberModalTitle">
      <a-form-model autocomplete="off" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            人员类型
          </span>
          <a-select placeholder="选择人员类型" v-model="memberForm.memberDuty" style="width: 100%" ref="memberDuty">
            <a-select-option v-for="item in duties" :key="item.value === void 0 ? item.label : item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            姓名
          </span>
          <a-input v-model="memberForm.memberName" style="width: 100%" placeholder="联系人姓名" ref="memberName" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">职务</span>
          <a-input v-model="memberForm.memberPost" style="width: 100%" placeholder="职务" ref="memberPost" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">电话</span>
          <a-input v-model="memberForm.phone" style="width: 100%" placeholder="电话/手机号码" ref="phone" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">工作经验</span>
          <a-textarea v-model="memberForm.experience" placeholder="工作经验" ref="experience" :rows="4" />
        </a-form-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getBudgets, listFinCates } from '@/api/project/common'
import { savePrj, viewPrj } from '@/api/project/funded'
import alldistricts from '@/utils/districts'
import { createNewBudget, convertBudgetsToTableData } from '@/utils/data'
import { readBudgetData } from '@/utils/xlsx'
const form = {
  type: undefined,
  capitalPoolId: undefined,
  capitalPoolName: '',
  name: '',
  cate: 1,
  type: undefined,
  startDate: undefined,
  endDate: undefined,
  recipients: [],
  amount: null,
  summary: '',
  supervisor: '',
  supervisorPhone: '',
  contractStartDate: undefined,
  contractEndDate: undefined,
  contractDates: [],
  dates: [],
  districts: [],
  bnfPeople: null,
  bnfPeopleIndirect: null,
}
const memberForm = {
  id: undefined,
  memberName: '',
  memberDuty: undefined,
  phone: '',
  memberPost: '',
  experience: '',
  memberState: 1,
}
export default {
  name: 'ProjectDraft',
  data() {
    return {
      projectId: this.$route.query.id,
      currentStep: 0,
      project: {},
      form: { ...form },
      memberList: [],
      finCates: [],
      addressList: [],
      districts: alldistricts,
      fileMark: this.$utils.uuid(),
      saving: false,
      applied: false,
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      memberModal: false,
      memberModalTitle: '',
      memberForm: { ...memberForm },
      budgets: [],
      expandedBudgetKeys: [],
      showYearPanel: false,
    }
  },
  computed: {
    hasChildren() {
      return this.budgets.some(item => item.children && item.children.length)
    },
    rootFinCates() {
      return [...new Set(this.finCates.map(d => d.cateRoot))].sort((a, b) => a - b)
    },
    duties: vm => vm.$store.state.app.memberDuties,
    recipientTypes: vm => vm.$store.state.app.recipientTypes,
  },
  watch: {
    budgets: {
      handler() {
        let amountTotal = 0
        this.budgets.forEach(budget => {
          if (budget.children && budget.children.length) {
            let total = undefined
            budget.children.forEach(item => {
              if (typeof item.amount === 'number') {
                total = total ? this.$utils.add(total, item.amount) : item.amount
              }
            })
            budget.amount = total
            amountTotal += total || 0
          }
        })
        let sumRecord = this.budgets.find(d => d.sum)
        if (sumRecord) {
          sumRecord.amount = amountTotal
        } else {
          if (this.budgets.length) {
            this.budgets.push({
              sum: true,
              name: '合计',
              amount: amountTotal,
              isRoot: 1,
            })
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
        this.loadBudgets()
      } else {
        this.onAddAddress(0)
      }
    },
    load() {
      this.loading = true
      let id = this.projectId
      viewPrj(id, true).then(({ data }) => {
        if (data.success) {
          let { name, type, amount, contractEndDate, contractStartDate, startDate, endDate, supervisor, supervisorPhone, summary, hzInfo: { recipients, bnfPeople, bnfPeopleIndirect }, addresses, members, files} = data.result
          this.listCates(type)
          this.project = data.result
          this.form = {
            id,
            name,
            type,
            amount,
            contractDates: [contractStartDate, contractEndDate],
            contractStartDate,
            contractEndDate,
            dates: startDate && endDate ? [startDate.substring(0, 10), endDate.substring(0, 10)] : [],
            startDate,
            endDate,
            supervisor,
            supervisorPhone,
            summary,
            recipients: recipients ? recipients.split('、'): [],
            bnfPeople,
            bnfPeopleIndirect,
          }
          this.fileList1 = files
            .filter(file => file.fileType === 101)
            .map(file => ({
              uid: file.fileId,
              fileId: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              belongId: id,
              fileSign: 'P01',
            }))
          this.fileList2 = files
            .filter(file => file.fileType === 102)
            .map(file => ({
              uid: file.fileId,
              fileId: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              belongId: id,
              fileSign: 'P01',
            }))
          this.fileList3 = files
            .filter(file => file.fileType === 103)
            .map(file => ({
              uid: file.fileId,
              fileId: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              belongId: id,
              fileSign: 'P01',
            }))
          this.fileList4 = files
            .filter(file => file.fileType === 104)
            .map(file => ({
              uid: file.fileId,
              fileId: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              belongId: id,
              fileSign: 'P01',
            }))
          this.memberList = members.map(d => ({ uid: this.$utils.uuid(), ...d }))
          if (addresses.length > 0) {
            this.addressList = addresses.map(({ id, province, city, district, addr }) => {
              let districts = []
              if (province) {
                districts.push(province)
              }
              if (city) {
                districts.push(city)
              }
              if (district) {
                districts.push(district)
              }
              return {
                id,
                districts,
                addr,
              }
            })
          } else {
            this.onAddAddress()
          }
        }
      })
    },
    listCates(projectType) {
      listFinCates({ projectType, pageSize: -1 }).then(({ data }) => {
        if (data.success) {
          this.finCates = data.result.records
        }
      })
    },
    onTypeSelect(value) {
      console.log('form.type', value)
      this.listCates(value)
      this.budgets.forEach(item => {
        if (item.children) {
          item.children.forEach(d => {
            d.cateId = undefined
            d.cateRoot = undefined
            d.cateName = ''
          })
        }
      })
    },
    loadBudgets() {
      getBudgets(this.projectId).then(({ data }) => {
        if (data.success) {
          let records = convertBudgetsToTableData(data.result)
          this.budgets = records
          this.expandedBudgetKeys = records.filter(d => d.children && d.children.length).map(d => d.uid)
        }
      })
    },
    handleReset() {
      if (this.projectId) {
        this.load()
      } else {
        this.memberList = []
        this.addressList = []
        this.onAddAddress()
        this.form = { ...form }
      }
    },
    handleUploadChange(info, ref, count = 1) {
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, count)
        this.$refs[ref].$el.classList.remove('uploader-empty')
      }
    },
    handleInputChange(record) {
      let { price, quantity } = record
      if (this.$utils.isNum(price) && this.$utils.isNum(quantity)) {
        record.amount = this.$utils.add(parseFloat(price) * parseFloat(quantity))
      }
    },
    nextStep() {
      let { type, name, amount, contractDates, dates, supervisor, supervisorPhone, summary } = this.form
      this.$message.destroy()
      if (!type) {
        this.$message.warning('请选择项目类型')
        this.$refs.type.focus()
        return
      }
      if (name.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.name.focus()
        return
      }
      if (!this.$utils.isNum(amount)) {
        this.$message.warning('请输入筹款金额')
        this.$refs.amount.focus()
        return
      }
      if (contractDates.length === 0) {
        this.$message.warning('请选择协议周期')
        this.$refs.datePicker.focus()
        return
      }
      if (dates.length === 0) {
        this.$message.warning('请选择实施时间')
        this.$refs.datePicker2.focus()
        return
      }
      if (supervisor.trim() === '') {
        this.$message.warning('请输入项目负责人')
        this.$refs.supervisor.focus()
        return
      }
      if (supervisorPhone.trim() === '') {
        this.$message.warning('请输入负责人联系电话')
        this.$refs.supervisorPhone.focus()
        return
      }
      let addresses = this.addressList.filter(item => item.districts[0])
      if (addresses.length === 0) {
        this.$message.warning('请选择项目实施地点')
        if (this.$refs['districts-0'] && this.$refs['districts-0'][0]) {
          this.$refs['districts-0'][0].focus()
        }
        return
      }
      if (summary.trim() === '') {
        this.$message.warning('请输入项目概述')
        this.$refs.summary.focus()
        return
      }
      let members = this.memberList
      if (members.length === 0) {
        this.$message.warning('请添加项目管理人员')
        return
      }
      let { fileList1, fileList2, fileList3 } = this
      if (fileList1.length === 0) {
        this.$message.warning('请上传项目合作协议及承诺书')
        this.$refs.fileList1.$el.classList.add('uploader-empty')
        return
      }
      if (fileList2.length === 0) {
        this.$message.warning('请上传合作申请书')
        this.$refs.fileList2.$el.classList.add('uploader-empty')
        return
      }
      if (fileList3.length === 0) {
        this.$message.warning('请上传预算表')
        this.$refs.fileList3.$el.classList.add('uploader-empty')
        return
      }
      this.currentStep = 1
    },
    onAddAddress(index = 0) {
      let len = this.addressList.length
      this.addressList.splice(index, 0, {
        seq: len + 1,
        districts: [],
        addr: '',
      })
    },
    onSaveMember() {
      let { uid, memberName, memberDuty, memberPost, experience, phone } = this.memberForm
      memberName = memberName.trim()
      this.$message.destroy()
      if (!memberDuty) {
        this.$message.warning('请选择人员类型')
        this.$refs.memberDuty.focus()
        return
      }
      if (memberName === '') {
        this.$message.warning('请输入人员姓名')
        this.$refs.memberName.focus()
        return
      }
      let formData = {
        uid,
        memberName,
        memberDuty,
        memberPost: memberPost.trim(),
        experience: experience.trim(),
        phone: phone.trim()
      }
      let idx = this.memberList.findIndex(d => d.uid === uid)
      this.memberList.splice(idx > -1 ? idx : this.memberList.length, 1, formData)
      this.memberModal = false
    },
    openMemberForm(data) {
      if (data) {
        this.memberForm = { ...memberForm, ...data }
        this.memberModalTitle = '编辑人员'
      } else {
        this.memberModalTitle = '添加人员'
        this.memberForm = { ...memberForm, uid: this.$utils.uuid() }
      }
      this.memberModal = true
    },
    cancelMemberModal() {
      this.memberModal = false
    },
    onDateRangeChange(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.contractStartDate = startDate
      this.form.contractEndDate = endDate
    },
    onDateRangeChange2(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.startDate = startDate ? `${startDate} 00:00` : startDate
      this.form.endDate = endDate ? `${endDate} 00:00` : endDate
    },
    onRemoveAddress(index) {
      this.addressList.splice(index, 1)
    },
    onRemoveMember(index) {
      this.memberList.splice(index, 1)
    },
    handleNewTask(action, task, index) {
      // let tasks = this.tasks
      let newItem = createNewBudget()
      newItem.editing = true
      newItem.uid = this.$utils.uuid()
      newItem.isRoot = 1
      if (action == 'append') {
        let sumIndex = this.budgets.findIndex(d => d.sum)
        if (sumIndex >= 0) {
          this.budgets.splice(sumIndex, 0, newItem)
        } else {
          this.budgets.push(newItem)
        }
      } else {
        this.budgets.splice(action == 'before' ? index : index + 1, 0, newItem)
      }
    },
    handleNewSubTask(action, item, index) {
      let newItem = createNewBudget()
      newItem.uid = this.$utils.uuid()
      newItem.isRoot = 0
      newItem.editing = true
      if (action == 'append') {
        newItem.puid = item.uid
        if (!item.children) {
          item.children = []
        }
        newItem.professionStartDate = item.startDate
        newItem.professionEndDate = item.endDate
        newItem.professionWeight = item.weight
        newItem.parent = item
        // newItem.professionStartDate = item.startDate
        item.children.push(newItem)
        this.budgets.splice(index, 1, { ...item })
        this.$nextTick(() => {
          this.expandedBudgetKeys.push(item.uid)
        })
      } else {
        let parent = this.budgets.find(d => d.uid == item.puid)
        newItem.parent = parent
        newItem.puid = parent.uid
        parent.children.splice(action == 'before' ? index : index + 1, 0, newItem)
      }
    },
    handleRemoveTask(item, index) {
      if (item.isRoot) {
        this.budgets.splice(index, 1)
        if (this.budgets.filter(d => !d.sum).length == 0) {
          this.budgets = []
        }
      } else {
        let parent = this.budgets.find(d => d.uid == item.puid)
        parent.children.splice(index, 1)
        if (parent.children.length == 0) {
          parent.children = undefined
        }
      }
    },
    onYearChange(date, record) {
      record.year = date.format('YYYY')
      record.showYearPanel = false
    },
    onYearPanelOpen(status, record) {
      record.showYearPanel = status
    },
    onCateRootChange(value, record, index) {
      record.cateId = undefined
      let parent = this.budgets.find(d => d.uid == record.puid)
      parent.children.splice(index, 1, record)
      console.log(value, record, index)
    },
    onCateChange(value, record, index) {
      // record.cateId = value
      record.cateName = value ? this.finCates.find(d => d.cateId == value).cateName : ''
      let parent = this.budgets.find(d => d.uid == record.puid)
      parent.children.splice(index, 1, record)
      console.log(value, record, index)
    },
    validBudget(item) {
      let { uid, name, isRoot, year, amount, cateRoot, cateId } = item
      if (!name || !name.trim()) {
        item.editing = true
        this.$message.warn('费用名称不能为空')
        this.$nextTick(() => {
          this.$refs[`budgetName-${uid}`].focus()
        })
        return false
      }
      if (!isRoot) {
        if (!cateRoot) {
          item.editing = true
          this.$message.warn('未设置费用分类')
          this.$nextTick(() => {
            this.$refs[`cateRoot-${uid}`].focus()
          })
          return false
        }
        if (!cateId) {
          item.editing = true
          this.$message.warn('未设置费用分类')
          this.$nextTick(() => {
            this.$refs[`cateId-${uid}`].focus()
          })
          return false
        }
        if (!year) {
          item.editing = true
          this.$message.warn('费用年度不能为空')
          this.$nextTick(() => {
            this.$refs[`year-${uid}`].focus()
          })
          return false
        }
        if (!amount) {
          item.editing = true
          this.$message.warn('预算金额不能为空')
          this.$nextTick(() => {
            this.$refs[`amount-${uid}`].focus()
          })
          return false
        }
      }
      return true
    },
    handleUploadBudgets(info) {
      let { file: { status }} = info
      this.handleUploadChange(info, 'fileList3')
      if (status == 'done' && this.fileList3.length) {
        readBudgetData(this.fileList3[0].originFileObj).then(data => {
          this.budgets = data
          this.expandedBudgetKeys = data.filter(d => d.children && d.children.length).map(d => d.uid)
        }).catch(err => {
          this.$message.warning(err)
        })
      }
    },
    handleSave() {
      let { type, name, amount, contractDates, dates, supervisor, supervisorPhone, summary } = this.form
      this.$message.destroy()
      if (!type) {
        this.$message.warning('请选择项目类型')
        this.$refs.type.focus()
        return
      }
      if (name.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.name.focus()
        return
      }
      if (!this.$utils.isNum(amount)) {
        this.$message.warning('请输入筹款金额')
        this.$refs.amount.focus()
        return
      }
      if (contractDates.length === 0) {
        this.$message.warning('请选择协议周期')
        this.$refs.datePicker.focus()
        return
      }
      if (dates.length === 0) {
        this.$message.warning('请选择实施时间')
        this.$refs.datePicker2.focus()
        return
      }
      if (supervisor.trim() === '') {
        this.$message.warning('请输入项目负责人')
        this.$refs.supervisor.focus()
        return
      }
      if (supervisorPhone.trim() === '') {
        this.$message.warning('请输入负责人联系电话')
        this.$refs.supervisorPhone.focus()
        return
      }
      let addresses = this.addressList.filter(item => item.districts[0])
      if (addresses.length === 0) {
        this.$message.warning('请选择项目实施地点')
        if (this.$refs['districts-0'] && this.$refs['districts-0'][0]) {
          this.$refs['districts-0'][0].focus()
        }
        return
      }
      if (summary.trim() === '') {
        this.$message.warning('请输入项目概述')
        this.$refs.summary.focus()
        return
      }
      let members = this.memberList
      if (members.length === 0) {
        this.$message.warning('请添加项目管理人员')
        return
      }
      let { fileList1, fileList2, fileList3 } = this
      if (fileList1.length === 0) {
        this.$message.warning('请上传项目合作协议及承诺书')
        this.$refs.fileList1.$el.classList.add('uploader-empty')
        return
      }
      if (fileList2.length === 0) {
        this.$message.warning('请上传合作申请书')
        this.$refs.fileList2.$el.classList.add('uploader-empty')
        return
      }
      if (fileList3.length === 0) {
        this.$message.warning('请上传预算表')
        this.$refs.fileList3.$el.classList.add('uploader-empty')
        return
      }
      if (!this.projectId) {
        // 新建项目从预算表导入
        // readBudgetData(fileList3[0].originFileObj).then(data => {
        //   this.budgets = data
        //   this.expandedBudgetKeys = data.filter(d => d.children && d.children.length).map(d => d.uid)
        // })
      }
      this.$confirm({
        title: '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(false)
        },
      })
    },
    handleConfirm(nextStep) {
      this.$message.destroy()
      let { type, name, amount, contractDates, dates, supervisor, supervisorPhone, summary } = this.form
      this.$message.destroy()
      if (!type) {
        this.$message.warning('请选择项目类型')
        this.$refs.type.focus()
        return
      }
      if (name.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.name.focus()
        return
      }
      if (!this.$utils.isNum(amount)) {
        this.$message.warning('请输入筹款金额')
        this.$refs.amount.focus()
        return
      }
      if (contractDates.length === 0) {
        this.$message.warning('请选择协议周期')
        this.$refs.datePicker.focus()
        return
      }
      if (dates.length === 0) {
        this.$message.warning('请选择实施时间')
        this.$refs.datePicker2.focus()
        return
      }
      if (nextStep) {
        let budgets = this.budgets
        if (budgets.length === 0) {
          this.$message.warn('未添加项目预算明细')
          return
        }
        for (let index = 0; index < budgets.length; index++) {
          let item = budgets[index]
          if (!this.validBudget(item)) {
            return false
          }
          if (item.children) {
            for (let i = 0; i < item.children.length; i++) {
              if (!this.validBudget(item.children[i])) {
                return false
              }
            }
          }
        }
      }
      this.$confirm({
        title: nextStep ? '确认提交？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { id, type, name, contractDates, dates, amount, supervisor, supervisorPhone, recipients = [], bnfPeople, bnfPeopleIndirect, summary } = this.form
      let { fileList1, fileList2, fileList3, fileList4, fileMark } = this
      let addresses = this.addressList.filter(item => item.districts[0])
      let fileIds = fileList1.map(d => d.fileId).concat(fileList2.map(d => d.fileId)).concat(fileList3.map(d => d.fileId)).concat(fileList4.map(d => d.fileId))
      let budgets = this.budgets.filter(d => !d.sum).map(({ budgetId, name, amount, children }) => {
        let budget = {
          budgetId, name, amount,
        }
        if (children && children.length) {
          budget.children = children.map(item => ({
            budgetId: item.budgetId,
            pid: item.pid,
            name: item.name,
            year: item.year,
            quantity: item.quantity,
            price: item.price,
            amount: item.amount,
            remark: item.remark,
            cateRoot: item.cateRoot,
            cateId: item.cateId,
            cateName: item.cateName,
          }))
        }
        return budget
      })
      let params = {
        id,
        type,
        name,
        contractStartDate: contractDates[0],
        contractEndDate: contractDates[1],
        startDate: dates[0] ? `${dates[0]} 00:00` : undefined,
        endDate: dates[1] ? `${dates[1]} 00:00` : undefined,
        amount,
        supervisor,
        supervisorPhone: supervisorPhone.trim(),
        summary,
        fileIds,
        fileMark,
        addresses: addresses.map(({ id, districts, addr }) => ({ id, province: districts[0], city: districts[1], district: districts[2], addr })),
        budgets,
        members: this.memberList,
        hzInfo: {
          recipients: recipients.length ? recipients.join('、') : undefined,
          bnfPeople,
          bnfPeopleIndirect,
        },
        nextStep,
      }
      this.saving = true
      savePrj(params)
        .then(({ data }) => {
          if (data.success) {
            if (nextStep) {
              this.applied = true
            } else {
              this.$message.success('操作成功')
              this.$router.push('../list')
            }
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
  },
  created () {
    this.init()
  },
}
</script>
